import Font from '@maxpreps/shared/styles/font';
import React from 'react';
import styled from 'styled-components';
import THEME from '../../../styles/colors';
import StyledText from '../../../ui/Text/StyledText';
import Anchor from '../../Anchor/Anchor';
import Image from '../../Image/Image';

const StyledMediaDropdownList = styled.ul`
  padding: 0 20px;
  text-align: left;
  min-width: 324px;

  & > li {
    &:not(:last-child) {
      border-bottom: 1px solid ${THEME.general.border};
    }
    > a {
      padding: 16px 0;
      display: grid;
      grid-template-columns: 1fr auto;
      grid-gap: 16px;
    }
  }
`;

const StyledMediaDropdownTitle = styled.h3`
  text-transform: uppercase;
  letter-spacing: 1.15px;

  color: ${THEME.text.secondary};
  text-align: left;
  padding: 8px 20px;
`;

interface IMediaDropdownListProps {
  links: {
    href: string;
    thumbnailUrl: string;
    text: string;
    description: string;
  }[];
  title: string;
}

const MediaDropdownList: React.FC<IMediaDropdownListProps> = ({
  links,
  title
}) => (
  <>
    <StyledMediaDropdownTitle className={Font.f16_bold_tall}>
      {title}
    </StyledMediaDropdownTitle>
    <StyledMediaDropdownList>
      {links.map(item => {
        const { href, thumbnailUrl, text, description } = item;
        return (
          <li key={text}>
            <Anchor href={href}>
              <Image
                src={thumbnailUrl}
                alt={text}
                size={65}
                borderRadius={'4px'}
              />
              <div>
                <StyledText
                  as="div"
                  className={Font.f14_bold_tall}
                  $color={THEME.text.primary}
                >
                  {text}
                </StyledText>
                <StyledText
                  className={Font.f14_tall}
                  $color={THEME.text.secondary}
                >
                  {description}
                </StyledText>
              </div>
            </Anchor>
          </li>
        );
      })}
    </StyledMediaDropdownList>
  </>
);

export default MediaDropdownList;
